import * as Yup from "yup";
import { CPfValidator } from "../../Utils/CpfValidation";
import { IuguService } from "../Shellhost/ShellHost";

const creditCardValidations = {
  credit_card_number: Yup.string().test(
    "credit_card_valid",
    "Informe um Cartão de crédito válido",
    function (val) {
      const isPayableCreditCard = (this as any).parent.payable_with || "";

      if (isPayableCreditCard === "credit_card") {
        return IuguService.utils.validateCreditCardNumber(val || "");
      } else {
        return true;
      }
    }
  ),
  credit_card_cvv: Yup.string().test(
    "credit_cvv_valid",
    "Informe um CVV válido",
    function (val) {
      const isPayableCreditCard = (this as any).parent.payable_with || "";

      if (isPayableCreditCard === "credit_card") {
        const creditCardNumber = (this as any).parent.credit_card_number || "";
        const brand = IuguService.utils.getBrandByCreditCardNumber(
          creditCardNumber
        );

        if (brand === false) {
          return false;
        } else {
          const valid = IuguService.utils.validateCVV(
            val || "",
            brand as string
          );
          return valid;
        }
      } else {
        return true;
      }
    }
  ),
  credit_card_expiration: Yup.string().test(
    "credit_card_valid",
    "Data de expiração inválida",
    function (val) {
      const isPayableCreditCard = (this as any).parent.payable_with || "";

      if (isPayableCreditCard === "credit_card") {
        return IuguService.utils.validateExpirationString(val || "");
      } else {
        return true;
      }
    }
  ),
  credit_card_name: Yup.string().test(
    "credit_card_valid",
    "Data de expiração inválida",
    function (val) {
      const isPayableCreditCard = (this as any).parent.payable_with || "";

      if (isPayableCreditCard === "credit_card") {
        return (val || "").split(" ").length > 1;
      } else {
        return true;
      }
    }
  ),
};

const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Informe um email valido")
    .required("Informe um email valido"),
  password: Yup.string().required("Informe sua senha"),
  ...creditCardValidations,
  payable_with: Yup.string()
    .required("Informe a forma de pagamento")
    .oneOf(
      ["credit_card", "bank_slip", "pix"],
      "Informe uma forma de pagamento válida"
    ),
});

const RegisterSchema = Yup.object().shape({
  nome: Yup.string().required("Informe seu nome"),
  email: Yup.string()
    .email("Informe um e-mail valido")
    .required("Informe seu email"),
  confirm_email: Yup.string()
    .email("Informe um e-mail valido")
    .required("Informe seu email")
    .oneOf([Yup.ref("email"), null], "Informe o mesmo e-mail"),
  password: Yup.string().required("Digite uma senha"),
  ...creditCardValidations,
  confirm_password: Yup.string()
    .required("Informe sua senha")
    .oneOf([Yup.ref("password"), null], "Informe a mesma senha"),
  cpf: Yup.string()
    .required("Informe seu CPF")
    .test("lenght", "Informe um CPF valido", (val) =>
      CPfValidator.TestaCPF(val || "")
    ),
  telefone_celular: Yup.string()
    .required("Informe seu celular")
    .test(
      "lenght",
      "Informe um celular valido",
      (val) => val?.replace(/\D+/g, "").toString().length === 11
    ),
  nascimento: Yup.string()
    .required("Informe sua data de nacimento 00/00/0000")
    .test("lenght", "Informe uma data de nascimento valida", (val) =>
      /^\d{1,2}\/\d{1,2}\/\d{4}$/g.test(val || "")
    ),
  sexo: Yup.string().required("Informe seu sexo"),
  payable_with: Yup.string()
    .required("Informe a forma de pagamento")
    .oneOf(
      ["all", "credit_card", "bank_slip", "pix"],
      "Informe uma forma de pagamento válida"
    ),

  endereco: Yup.object().shape({
    cep: Yup.string().required("Informe o Cep"),
    numero: Yup.number().required("Informe o Número"),
    logradouro: Yup.string().required("Informe seu endereço"),
    bairro: Yup.string().required("Informe o Bairro"),
    complemento: Yup.string().required("Informe o Complemento"),
    estado: Yup.string().required("Informe um Cep Valido"),
    cidade: Yup.string().required("Informe um Cep Valido"),
    latitude: Yup.number().required("Informe um Cep Valido"),
    longitude: Yup.number().required("Informe um Cep Valido"),
  }),
});

export { LoginSchema, RegisterSchema };
